<template>
  <router-view ref="workspace"></router-view>
</template>

<script>
export default {
  components: {},
  mixins: [],
  props: {},
  provide: function () {
    return {
      request: {
        table: 'getStepTemplateTable',
        detail: 'getStepTemplateDetail',
        create: 'createStepTemplateData',
        update: 'updateStepTemplateData',
      },
      scope: '',
      create: this.create,
      update: this.update,
      visibleGuide: true,
    }
  },
  data () {
    return {}
  },
  computed: {},
  watch: {},
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    create (form) {
      const stepForm = this.stepFormData(filter.copyJson(form))
      request.common('createStepTemplateData', stepForm).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          this.$refs.workspace.onReload()
        }, () => {
          this.$router.push({path: '/step-template/table/'})
        })
      })
    },
    update (id, form) {
      this.updataStepData(id, form)
    },
    updataStepData (id, form) {
      const stepForm = this.stepFormData(filter.copyJson(form))
      request.common('updateStepTemplateData', {id, ...stepForm}).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否前往列表页面？', '提示', {type: 'success'}).then(() => {
          this.$router.push({path: '/step-template/table/'})
        })
      })
    },
    stepFormData (form) {
      const questions = JSON.parse(form.json)
      questions.forEach(item => {
        delete item.keyin_ids
      })
      form.json = JSON.stringify(questions)
      return form
    },
    keyinFormData (id, form) {
      return {tpl_id: id, ...form, origin_json: form.json}
    },
  },
  filters: {},
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/step-template/pages/StepTemplateForm.vue